export { ar } from '@payloadcms/translations/languages/ar'
